module.exports = __webpack_public_path__ + "img/icon_Architecture_G.f401433f.svg";